module.exports = __webpack_public_path__ + "img/2.2dbc32e9.jpg";